import { LinkPreview } from 'components/linkPreview/linkPreview.module';
import { checkIfAnchorTag, linkify } from 'helpers/helpers';
import './smo.scss';

export const SmoTemplate = (model) => {
	const { message, message_id } = model || {};
	const msg = typeof message?.data?.message === 'string' ? message?.data?.message : '';

	const linkifyString = msg && linkify(msg);

	const isAnchorTag = linkifyString && checkIfAnchorTag(linkifyString);

	const getLinkPreview = () => {
		const linkPreview = new LinkPreview({
			msg: linkifyString,
			message_id,
			is_iframe: false,
		});
		return linkPreview.render();
	};

	const messageToShow = isAnchorTag ? getLinkPreview() : msg;

	/* html */
	const smoMessage = messageToShow ? `<span class="engt-msg-text">${messageToShow}</span>` : '';

	const renderMessage = () =>
		/* html */
		`<span class="engt-msg engt-msg-bot engt-msg-border-bot engt-msg-smo">
			${smoMessage}
			<smo-options></smo-options>
			<edit-btn></edit-btn>
		</span>`;

	const html = message ? renderMessage() : '';

	return html;
};
